import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    sendDefaultPii: false,
  });
}

export function setSentryUser(user: { id: string; email?: string } | null) {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  if (user) {
    Sentry.setUser({ id: user.id });
  } else {
    Sentry.setUser(null);
  }
}

/**
 * Something failed that the person only sees as a thing missing (a model that
 * stays a box, a sky that stays plain): said in the console and sent to
 * Sentry. Links lose their query string, which is where their signatures are.
 */
export function reportFailure(what: string, error: unknown, context: { url?: string } = {}) {
  console.error(what, context.url, error);
  Sentry.captureException(error instanceof Error ? error : new Error(what), {
    tags: { failure: what },
    extra: { ...(context.url ? { url: context.url.split("?")[0] } : {}), ...(error instanceof Error ? {} : { cause: String(error) }) },
  });
}

export { Sentry };
